import React from "react";
import SvGraphics from "../../../../assets/SvGraphics";
import {renderToString} from "react-dom/server";

export class CannabisPDFDenied {


    params

    constructor(params) {
        this.params = params
    }

    getPatientAge() {
        if (this.params.Date_of_birth && this.params.Date_of_birth !== null && this.params.Date_of_birth !== "" ) {
            let todayDate = new Date().toISOString()
            let todayExactDate = (todayDate.split('T'))[0].split('-')
            let currentYear = todayExactDate[0]
            let currentMonth = todayExactDate[1]
            let birthDate = this.params.Date_of_birth ? this.params.Date_of_birth.toISOString() : ""
            let exactDate = (birthDate.split('T'))[0].split('-')
            let yearDiff = currentYear - exactDate[0]
            let monthDiff = currentMonth - exactDate[1]
            if (monthDiff < 0) {
                return (yearDiff - 1) + "." + (12 + monthDiff)
            } else {
                return yearDiff + "." + (monthDiff)
            }
        }
        return ""
    }

    initHTML() {
        let emailSVG = renderToString(<SvGraphics style={{marginTop: '6px', marginRight: '10px', marginLeft: '5px'}}
                                                  svgname={"email-iconBlack"} width={'9px'} min-height={'14px'}/>)
        let logo = renderToString(<SvGraphics style={{marginTop: '6px', marginRight: '25px', marginLeft: '5px'}}
                                              svgname={"painClinicLogo"} width={'150px'} min-height={'14px'}/>)

        let phoneSVG = renderToString(<SvGraphics style={{marginRight: '15px', marginLeft: '5px'}}
                                                  svgname={'phone-iconBlack'} width={'9px'} min-height={'14px'}/>)
        let checkSVG = renderToString(<SvGraphics svgname={'cancel-icon'} width={'11px'} min-height={'14px'} style={{marginTop: '10px',marginLeft: '10px'}}/>)
        let firstName = this.params.First_name ? this.params.First_name : ""
        let lastName = this.params.Last_name ? this.params.Last_name : ""
        let id = this.params.ID_passport ? this.params.ID_passport : ""
        let age = this.getPatientAge()
        let phone = this.params.Phone_num1 ? this.params.Phone_num1 : ""
        let mail = this.params.Email ? this.params.Email : ""

        let currentDate =new Date()
        currentDate=currentDate.toISOString().split('T')
        let dateString =currentDate[0].split('-').reverse().join('/')
        let statusText = this.params.statusText ? this.params.statusText : ""
        let diagnonses_ICD = this.params.medical_diagnoses_icd_name && this.params.medical_diagnoses_icd_name.label.toLowerCase() !== "other" ?
            this.params.medical_diagnoses_icd_name.label : this.params.other_diagnoses?this.params.other_diagnoses:""

        let programm = this.params.choose_programm ? this.params.choose_programm : ""
        programm = programm === "new" ? "הוצאת רישיון חדש" : programm
        programm = programm === "renew" ? "חידוש רישיון למטופלים קיימים" : programm
        programm = programm === "renew2" ? "חידוש רישיון למטופלים חדשים" : programm
        programm = programm === "change" ? "חידוש רישיון מעל שנה (ביקור II)" : programm
        programm = programm === "newPrescription" ? "הוצאת מרשם חדש"  : programm
        programm = programm === "renewPrescription" ? "חידוש מרשם למטופלים קיימים" : programm
        programm = programm === "renew2Prescription" ? "חידוש מרשם למטופלים חדשים" : programm
        let patientTreat = this.params.patientTreatments ? this.params.patientTreatments[0] : []
        let tratmentCat = patientTreat && patientTreat.TreatmentCategory ? patientTreat.TreatmentCategory : ""
        let tratmenDosage = patientTreat && patientTreat.TreatmentMonthlyDosage ? patientTreat.TreatmentMonthlyDosage : ""
        let tratmenTakeMethod = patientTreat && patientTreat.TreatmentIntakeMethod ? patientTreat.TreatmentIntakeMethod : ""

        tratmenTakeMethod = tratmenTakeMethod === "Flower" ? "פרח" : tratmenTakeMethod
        tratmenTakeMethod = tratmenTakeMethod === "Oil drops" ? "טיפות שמן" : tratmenTakeMethod
        tratmenTakeMethod = tratmenTakeMethod === "Precision Dosing Devices" ? "משאף למינון מדוד" : tratmenTakeMethod
        tratmenTakeMethod = tratmenTakeMethod === "Other" ? "אחר" : tratmenTakeMethod


        let indication =this.params.patient_indication
        indication =indication==="Other" || indication==="אחר" ?this.params.other_patient_type_indication:indication
        if(indication === null ||indication === undefined )
            indication=""

        return (
            '<html dir="rtl" >' +
            ' <head></head>' +
            '<style>' +
            ' .pdf-Body {margin:0;zoom: 100%;max-width: 1000px;background:white;font-family: Assistant, sans-serif;}' +
            ' .pdf-Header {display: flex;justify-content:space-evenly;align-items:center;background:#f6f6f6;height:100px;width: 100%; }' +
            ' .pdf-SubHeader1 {min-width:51%;max-width:51%;display: flex;justify-content:start;font-family: Assistant, sans-serif;font-size: 1.375rem;width:max-content;align-items: center;color: #005f7f; }' +
            ' .pdf-SubHeader2 {background: white;height: 67px;min-width:35%;max-width:36%;font-family: Assistant, sans-serif;font-size: 0.875rem;}' +
            ' .pdf-Title {margin-left: 10px;font-weight: bold;width:50%;font-size: 1.2rem;}' +
            ' .pdf-Date { font-weight: 300;font-size: 1.2rem;width: 20%;}' +
            ' .leumit-Title { margin-top:14px;margin-right:14px;margin-bottom: 3px;font-weight: bold;height: 28%;}' +
            ' .leumit-Address {display: flex;align-items: center;justify-content: space-around;font-weight: 300;opacity: 0.5;height: 30%;width:100%;}' +
            ' .personal-Info { border-radius: 10px;box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1);width:90%;min-height: 480px;}' +
            ' .personal-Info2 { border-radius: 10px;box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1);width:90%;height: 129px}' +
            ' .personal-InfoTitle {background:#f6f6f6;width:100%;border-top-left-radius: ' +
            '10px;border-top-right-radius: 10px;padding-right: 34px;color: #005f7f;font-weight: bold;display:flex;align-items: center;height: 33px;}' +
            '.personal-infoSubTitlesContainer {display: flex;align-items: start;}' +
            '.personal-infoSubTitlesContainer2 {display: flex;align-items: center;width: 100%}' +
            '.personal-infoSubTitles{font-size:0.875rem;font-family: Assistant, sans-serif;font-weight: 600;margin-top: 27px;}' +
            '.personal-infoContent {margin-top: 4px;font-family: Assistant, sans-serif;font-size: 1.125rem;font-weight: 300;opacity: 0.5;min-height: 15px;}' +
            '.personal-infoContentFooter {margin-top: 4px;font-family: Assistant, sans-serif;font-size: 0.875rem;font-weight: 300;opacity: 0.5}' +
            '.clinic-infoContent {font-family: Assistant, sans-serif;font-size: 0.8rem;font-weight: 300;opacity: 0.5;width: 73%;}' +
            '.personal-border {border-top: 1px solid #dedbdb;margin-top: 26px;margin-right: 35px;margin-left: 35px;}' +
            '</style>' +
            '<body class="pdf-Body">' +
            '<div class="pdf-Header" dir="rtl">' +
            '<div dir="rtl" class="pdf-SubHeader1">' +
            '<div class="pdf-Title">סיכום בקשה לרישיון קנאביס רפואי</div>' +
            '<div class="pdf-Date">'+dateString+'</div>' +
            '<div style="width: 30%;">'+
            `${logo}`+'</div></div>' +
            '<div class="pdf-SubHeader2" style="margin-right: 50px;" >' +
            '<div class="leumit-Title"> המרכז הארצי לרפואת כאב</div>' +
            '<div class="leumit-Address">' +
            `<div style="display: flex;align-items: center;width:40%;"><div style="width: 22%;">${phoneSVG}</div>` +
            '<div dir="rtl" class="clinic-infoContent">073-3807972</div></div>' +
            `<div style="display: flex;align-items: center;width:60%;"><div style="width: 13%;">${emailSVG}</div>  ` +
            '<div dir="rtl" class="clinic-infoContent">pain@sade.group</div></div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '<div style="display: flex;align-items: center;justify-content: center;margin-top: 32px">' +
            '<div class="personal-Info">' +
            '<div style="display: flex">' +
            '<div class="personal-InfoTitle">פרטים אישיים</div>' +
            '</div>' +
            '<div class="personal-infoSubTitlesContainer">' +
            '<div style="width: 19%;margin-right: 35px;">' +
            '<div class="personal-infoSubTitles">שם מלא</div>' +
            '<div dir="rtl" class="personal-infoContent">' + firstName + ' ' + lastName + '</div>' +
            '</div>' +
            '<div style="width: 19%">' +
            '<div class="personal-infoSubTitles">תעודת זהות</div>' +
            '<div class="personal-infoContent">' + id + '</div>' +
            '</div>' +
            '<div style="width: 19%">' +
            '<div class="personal-infoSubTitles">גיל</div>' +
            '<div class="personal-infoContent">' + age + '</div>' +
            '</div>' +
            '<div style="width: 19%">' +
            '<div class="personal-infoSubTitles">טלפון</div>' +
            '<div class="personal-infoContent">' + phone + '</div>' +
            '</div>' +
            '</div>' +
            '<div class="personal-infoSubTitlesContainer">' +
            '<div style="width: fit-content;margin-right: 35px;">' +
            '<div class="personal-infoSubTitles">אימיל</div>' +
            '<div class="personal-infoContent">' + mail + '</div>' +
            '</div>' +
            '</div>' +
            '<div class="personal-border"></div>' +
            '<div class="personal-infoSubTitlesContainer" style="height: 120px;">' +
            '<div style="width: 34%;margin-right: 35px;">' +
            '<div class="personal-infoSubTitles">אינדיקציה</div>' +
            '<div class="personal-infoContent">' + indication + '</div>' +
            '</div>' +
            '<div style="width: 59%;margin-right: 35px;">' +
            '<div class="personal-infoSubTitles" style="word-break: break-all;width: 493px;">אבחנה</div>' +
            '<div class="personal-infoContent" style="height: 0px;">' + diagnonses_ICD + '</div>' +
            '</div>' +
            '</div>' +
            '<div class="personal-border"></div>' +
            '<div class="personal-infoSubTitlesContainer">' +
            '<div style="width: 34%;margin-right: 35px;">' +
            '<div class="personal-infoSubTitles">סוג בקשה</div>' +
            '<div class="personal-infoContent">' + programm+ '</div>' +
            '</div>' +
            '<div style="width: 30%;margin-right: 35px;">' +
            '<div class="personal-infoSubTitles">סטטוס</div>' +
            '<div style="display: flex">' +
            ` ${checkSVG}` +
            '<div class="personal-infoContent">נדחה</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '<div style="overflow-wrap: break-word;margin-right: 35px; min-height: 20px">'+
            '<div class="personal-infoSubTitles">סיבה להחלטה</div>'+
            '<div class="personal-infoContent">' + statusText + '</div>'+
            '</div>' +
            '</div>' +
            '</div>' +
            '<div style="overflow-wrap: break-word;margin-right: 70px;margin-top: 350px; min-height: 20px">'+
            '<div class="personal-infoContentFooter">מכיל מידע מוגן לפי חוק הגנת הפרטיות – המוסרו שלא כדין עובר עבירה</div>'+
            '</div>' +
            '</body>' +
            '</html>'
        )
    }
}
